export enum TOAST {
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
  SUCCESS = "success",
}
